import React from 'react'
import { logFrontendError } from '../utils/logger'

class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { failed: false }
  }

  static getDerivedStateFromError() {
    return { failed: true }
  }

  componentDidCatch(error, info) {
    const componentStack = String(info?.componentStack || '').trim()
    const component = componentStack.split('\n')[0]
    const stackTrace = [error?.stack, componentStack && `React component stack:\n${componentStack}`]
      .filter(Boolean)
      .join('\n\n')
    logFrontendError({ error, source: 'react', component, stackTrace })
  }

  render() {
    if (this.state.failed) {
      return (
        <main className="page-content" role="alert">
          <h1>Something went wrong</h1>
          <p>The error was recorded. Refresh the page to try again.</p>
          <button type="button" onClick={() => window.location.reload()}>Refresh</button>
        </main>
      )
    }
    return this.props.children
  }
}

export default AppErrorBoundary
